import { render, staticRenderFns } from "./TopPlayerStatsWidget.vue?vue&type=template&id=117011d6&scoped=true"
import script from "./TopPlayerStatsWidget.vue?vue&type=script&lang=js"
export * from "./TopPlayerStatsWidget.vue?vue&type=script&lang=js"
import style0 from "./TopPlayerStatsWidget.vue?vue&type=style&index=0&id=117011d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117011d6",
  null
  
)

export default component.exports